import { Sound } from '@/model/sound.ts'

export class SoundsList {
  readonly sounds: Sound[]

  constructor (sounds: Sound[]) {
    this.sounds = sounds
  }

  static fromJson (data: any): SoundsList {
    return new SoundsList(Array.isArray(data.sounds)
      ? data.sounds.map((element: any) => Sound.fromJson(element))
      : [])
  }
}
